<template>
	<div class="dashboard_profile container">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8>
          <v-card class="elevation-12">
            <v-toolbar color="indigo" dark flat>
              <v-toolbar-title>{{ $t('dashboard_profile') }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-tabs>
              <v-tab  color="indigo" dark>
                <v-icon left dark flat>mdi-account</v-icon>
                {{ $t('dashboard_basic') }}Basic
              </v-tab>
              <v-tab  color="indigo" dark>
                <v-icon left dark flat>mdi-lock</v-icon>
                {{ $t('dashboard_advanced') }}Advanced
              </v-tab>
              <v-tab-item>         
                <v-card-text>
                  <v-form ref="form" v-model="valid" lazy-validation id="basic">
                    <v-text-field v-model="basic.name"  label="User Name" ></v-text-field>

                    <v-text-field v-model="basic.email" :rules="emailRules" label="E-mail" required></v-text-field>

                    <v-text-field v-model="basic.address" :rules="addressRules" label="Address" ></v-text-field>

                    <v-text-field v-model="basic.phone" :rules="phoneRules" label="Phone Number" ></v-text-field>

                    <v-card-actions>
                      <v-btn rounded color="error" class="mr-4" @click="reset">Reset</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn rounded color="indigo" dark @click="updateProfile">Upgrade Basic</v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card-text>
              </v-tab-item>
              <v-tab-item>  
                  <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation id="advanced">
                      <v-text-field v-model="advanced.fullname" :rules="fullnameRules" label="Full Name" ></v-text-field>

                      <v-flex xs6 sm6 md6>
                        <input type="file" name="photoURL" @change="uploadImage">
                        <!-- Image Here -->
                      </v-flex>

                      <v-select v-model="advanced.province" :items="items" :rules="[v => !!v || 'Province is Required']" label="Pick Province" required></v-select>

                      <v-card-actions>
                        <div class="columns">
                          <div class="column is-6">
                            <v-btn rounded color="primary" class="mr-4" @click="resetPassword">{{ $t('auth_reset') }}</v-btn>
                          </div>
                          <div class="column is-6">
                            <v-btn rounded color="indigo" dark @click="updateAdvanced">{{ $t('advanced_upgrade') }}</v-btn>
                          </div>
                        </div>
                      </v-card-actions>
                    </v-form>
                  </v-card-text>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import {fb, db} from '@/firebase'

  export default {
    name:"dashboard_profile",
    props: {
      msg: String
    },

    data: () => ({
      valid: true,
      basic : {
        name: null,
        address: null,
        addressRules: [
          v => (v && v.length >= 8) || 'Address must be more than 8 characters',
        ],
        phone: null,
        phoneRules: [
          v => (v && v.length >= 9) || 'Phone Number must be more than 9 characters',
        ],
        email: null,
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ]
      },

      advanced : {
        fullname: null,
        fullnameRules: [
          v => (v && v.length >= 8) || 'Name must be more than 8 characters',
        ],
        photoURL : null,
        password: null,
        passwordRules: [
          v => (v && v.length >= 6) || 'Name must be more than 6 characters',
        ],
        confirmPassword: null,
        province: null,
        uid: null,
      },
      
      
      items: [
        'Lusaka',
        'Copperbelt',
        'Central',
        'Southern',
        'Northern',
        'Eastern',
        'Western',
        'North-Western',
        'Luapula',
        'Muchinga'
      ]
    }),

    firestore(){
      const user = fb.auth().currentUser;
      return {
        basic: db.collection('profiles').doc(user.uid)
      }
    },

    methods: {
      resetPassword() {
        const auth = fb.auth();
        auth.sendPasswordResetEmail(auth.currentUser.email).then(() => {
          /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Reset Sent, Check Email.'
          })
          
        }).catch((error) => {
          console.log(error)
          /* eslint-enable */
        })
      },

      updateProfile(){
        this.$firestore.basic.update(this.basic);
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'Profile updated successfully'
        })
        /* eslint-enable */
      },
      uploadImage(){

      },
      reset () {
        this.$refs.form.reset()
      }
    },

    created(){

    }
  }
</script>